module.exports = __webpack_public_path__ + "img/photo-01.f55aba3a.png";